window.Search || (window.Search = {});
Aedu.Search = Aedu.Search || {};